<template>
  <div class="p-top">
    <!-- メインビジュアル -->
    <div class="p-top__mv">
      <mv ref="mv"></mv>
    </div>
    
    <!-- コンセプト文 -->
    <div id="p-top__lead" class="p-top__lead">
      <lead ref="lead"></lead>
    </div>

    <!-- カテゴリ -->
    <div class="p-top__cat">

      <div class="c-category c-category--1">
        <div class="c-category__text" data-ref="categoryThumb1">
          <span></span>
        </div>
        
        <category-thumb ref="categoryThumb1" category="g20" max="3"></category-thumb>

        <div class="c-category__info">
          <h2>
            <span>GOLD</span>
            <span v-if="$store.getters.lang === 'ja'">K18</span>
          </h2>
          <template v-if="$store.getters.lang === 'en'">
            <p>Gold, which is the origin of the 999.9 brand name, brings a moderate weight and a dignified texture. The slender gold frame that is noticeable from its beautiful shine, harmonizes with Four Nines’ aspect of comfort providing an ideal frame balance. As a material used from ancient times that symbolizes nobility, this is the one of the most supreme frames which you can find in gold.</p>
          </template>
          <template v-else>
            <p>999.9 のブランド名の由来でもある金を用いたフレームは、程よい重量感と品格のある質感をもたらします。耐腐食性が高く錆びにくいという特徴を持つ金が、フォーナインズの求めるフレームバランスと絶妙に融合。美麗かつ心地よいフレームを実現します。古くから装飾品に用いられてきた、高貴さの象徴たる金を使用した至高の逸品です。</p>
          </template>
          <router-link 
          class="c-btnMore1" 
          :to="`/${$store.getters.pathPrefix}g20/`"
          @click.native="$store.commit('sendGA', {action: 'click', path: '', label: 'トップページ - Gold K18'});"
          >
            <span>Detail</span>
          </router-link>
        </div>
      </div>

      <div class="c-category c-category--2">
        <div class="c-category__text" data-ref="categoryThumb2">
          <span></span>
        </div>
        
        <category-thumb ref="categoryThumb2" category="npm10b" max="3"></category-thumb>

        <div class="c-category__info">
          <h2>
            <span>TORTOISESHELL</span>
            <span v-if="$store.getters.lang === 'ja'">鼈甲</span>
          </h2>
          <template v-if="$store.getters.lang === 'en'">
            <p>Tortoiseshell is a product made from sea turtles’ shell that lives in the Southern Sea.  Its beautiful texture and the natural colors have been popular as an art craft and decorative item since antient times.  The crossover of the unique tortoiseshell material which is lightweight, stable with smooth touch and Four Nines’ workmanship to create an ideal frame balance opens a new field of comfort. Tortoiseshell is a rare material which accentuates a mature and sophisticated impression surrounding the eyes.</p>
          </template>
          <template v-else>
            <p>鼈甲とは、南方に生息する海亀の一種・タイマイの甲羅を加工した製品のことを指し、古くから工芸品や装飾品として親しまれてきました。鼈甲を用いた眼鏡フレームは軽い、使っているうちに肌に馴染んでいく、汗で滑りにくい、変形がほとんどないといった特徴を持ちます。天然素材ならではの独特の自然な光沢と色合いが美しく、理想のフレームバランスと融合することで、他にはない魅力を持つフレームになるのです。</p>
          </template>
          <router-link 
          class="c-btnMore1" 
          :to="`/${$store.getters.pathPrefix}npm10b/`"
          @click.native="$store.commit('sendGA', {action: 'click', path: '', label: 'トップページ - Tortoise Shell'});"
          >
            <span>Detail</span>
          </router-link>
        </div>
      </div>

      <div class="c-category c-category--3">
        <div class="c-category__text" data-ref="categoryThumb3">
          <span></span>
        </div>
        
        <category-thumb ref="categoryThumb3" category="np13bf" max="3"></category-thumb>

        <div class="c-category__info">
          <h2>
            <span>BUFFALO HORN</span>
            <span v-if="$store.getters.lang === 'ja'">バッファローホーン</span>
          </h2>
          <template v-if="$store.getters.lang === 'en'">
            <p>Buffalo horn is a natural material with a unique beautiful texture. The buffalo horn carefully hand-finished by craftsmen fuses with Four Nines’ remarkable comfort and quality which we continuously pursuit for. The perfect blend of the of buffalo horn and Four Nines’ quality can never be compared with any others. The combination of Four Nines’ premium quality and the natural, one-of-a-kind material weave together to create the best frame balance which attracts and create new value.</p>
          </template>
          <template v-else>
            <p>バッファローホーンとは水牛の角を意味し、美しい風合いを放つ天然素材です。職人が丁寧に手仕上げした生地と、フォーナインズが追求してきた最良の心地よさが融合。高い機能性はもちろんのこと、バッファローホーンの生み出す柔らかな掛け味は、掛けていることを忘れるほど。フォーナインズ クオリティと天然素材が織りなす理想の1本を、ぜひご体感ください。</p>
          </template>
          <router-link 
          class="c-btnMore1" 
          :to="`/${$store.getters.pathPrefix}np13bf/`"
          @click.native="$store.commit('sendGA', {action: 'click', path: '', label: 'トップページ - Buffalo Horn'});"
          >
            <span>Detail</span>
          </router-link>
        </div>
      </div>
    </div>

    <!-- 商品 -->
    <div class="p-top__prod">
      <lineup></lineup>
    </div>
  </div>
</template>

<script>
import Mv from '@/_components/top/Mv';
import Lead from '@/_components/top/Lead';
import CategoryThumb from '@/_components/top/CategoryThumb';
import Lineup from '@/_components/Lineup';
import { gsap, Quart } from 'gsap';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// gsap
gsap.registerPlugin(ScrollSmoother, ScrollTrigger);

export default {
  components: {
    Mv,
    Lead,
    Lineup,
    CategoryThumb,
  },
  data() {
    return {
      ScrollSmoother: null,
      ispc: false,
      scrollObjects: [],
      resizeObserver: null,
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 初期設定
      vm.once();
    });
  },
  beforeRouteLeave(to, from, next) {
    // loading表示
    this.$store.commit('setShowLoad', true);
    
    setTimeout(() => {
      this.reset();
      next();
    }, this.$store.getters.loadTime * 1000);
  },
  beforeRouteUpdate (to, form, next) {
    next();
  },
  mounted() {},
  methods: {
    once() {
      this.resizeObserver = new ResizeObserver(this.resize);
      this.resizeObserver.observe(document.body);
      this.$nextTick(this.start);

      this.$emit('child-ready', '準備完了');
    },
    start() {
      this.$store.commit('setShowLoad', false);

      this.resize();

      this.slideshow();

      setTimeout(() => {
        this.$refs['mv'].start();
      }, 1000);
    },
    slideshow() {
      
    },
    setting() {
      let triggers = ScrollTrigger.getAll();
      triggers.forEach(function (trigger) {
          trigger.kill();
      });

      //if (gFNS.isDevice === 'pc') {
        //////////
        // gsap SmoothScroller
        //////////
        this.ScrollSmoother = ScrollSmoother.create({
          effects: false,
          smooth: 1,
          smoothTouch: 0.1,
          ignoreMobileResize: true,
          normalizeScroll: true,
          //onUpdate: this.scroll,
        });
      //}

      //////////
      // gsap ScrollTrigger
      //////////
      ScrollTrigger.normalizeScroll(true);
      
      // ヘッダー
      ScrollTrigger.create({
        trigger: '#p-top__lead',
        start: 'top top',
        scrub: true,
        ease: 'none',
        onToggle: (self) => {
          if (self.isActive || self.direction === 1) {
            this.$store.commit('setHeadBlack', true);
          } else {
            this.$store.commit('setHeadBlack', false);
          }
        },
      });

      // MV 
      this.scrollObjects.push('.c-mv__thumb');
      const tlmv = gsap.timeline();
      tlmv.to('.c-mv__thumb', {y: '50%', ease: 'none'});

      ScrollTrigger.create({
        animation: tlmv,
        trigger: '#c-mv',
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        ease: 'none',
      });

      // コンセプト文
      this.scrollObjects.push('#p-top__lead');
      this.scrollObjects.push('#c-lead__info');

      ScrollTrigger.create({
        trigger: '#p-top__lead',
        start: 'top top+=50%',
        scrub: true,
        ease: 'none',
        once: true,
        toggleClass: 'p-top__lead--toggle',
      });

      document.getElementById('c-lead__info').querySelectorAll('h2,p').forEach(wrap => {
        gsap.set(wrap, {
          scale: 1.1,
          y: '100%', 
          autoAlpha: 0, 
          filter: 'blur(10px)',
          webkitFilter: 'blur(10px)'
        });

        gsap.to(wrap, {
          scale: 1.0,
          y: '0%',
          autoAlpha: 1,
          filter: 'blur(0px)',
          webkitFilter: 'blur(0px)',
          ease: 'none',
          scrollTrigger: {
            trigger: wrap,
            start: 'top bottom',
            end: 'bottom top+=85%',
            ease: Quart.easeOut,
            scrub: true,
          }
        })
      });

      // カテゴリー
      this.scrollObjects.push('.c-category__text');
      this.scrollObjects.push('.c-category__thumb');
      this.scrollObjects.push('.c-category__info');

      gsap.utils.toArray('.c-category__text').forEach(wrap => {
        gsap.to(wrap, {
          y: '-50%',
          ease: 'none',
          scrollTrigger: {
            trigger: wrap,
            start: 'top bottom',
            end: 'bottom top',
            //ease: 'none',
            scrub: true,
          }
        });

        gsap.set(wrap, {
          scrollTrigger: {
            trigger: wrap,
            start: 'top center+=20%',
            scrub: true,
            once: true,
            toggleClass: 'c-category__text--toggle',
            onToggle: (self) => {
              if (self.isActive && self.direction === 1) {
                const refName = self.trigger.getAttribute('data-ref');
                this.$refs[refName].start();
              }
            }
          }
        });
      });

      gsap.utils.toArray('.c-category__info').forEach(wrap => {
        gsap.to(wrap, {
          y: '-30%',
          ease: 'none',
          scrollTrigger: {
            trigger: wrap,
            start: 'top bottom',
            end: 'bottom top',
            //ease: 'none',
            scrub: true,
          }
        })
      });

      document.querySelectorAll('.c-category__thumb').forEach(thumb => {
        const wrap = thumb.querySelector('.is-wrap');
        const img = thumb.querySelector('.is-wrap-image');
        const diff = wrap.getBoundingClientRect().height - thumb.getBoundingClientRect().height;

        wrap.style.top = -diff + 'px';
        gsap.killTweensOf(img);
        gsap.to(img, {
          y: diff,
          ease: 'none',
          scrollTrigger: {
            trigger: thumb,
            start: 'top bottom',
            end: 'bottom top',
            //ease: 'none',
            scrub: true,
          }
        })
      });

      // LINE UP
      this.scrollObjects.push('.c-product__text');

      gsap.set('.c-product__text', {
        scrollTrigger: {
          trigger: '.c-product__text',
          start: 'top center+=20%',
          scrub: true,
          //markers: true,
          once: true,
          toggleClass: 'c-product__text--toggle',
        }
      });
    },
    settingPC() {
      ScrollTrigger.refresh();
      ScrollTrigger.update();
    },
    settingSP() {
      ScrollTrigger.refresh();
      ScrollTrigger.update();
    },
    resize() {
      if (this.checkSP(900)) {
        // sp
        if (this.ispc) {
          this.ispc = false;
          this.settingSP();
        }
      } else {
        // pc
        if (!this.ispc) {
          this.ispc = true;
          this.settingPC();
        }
      }

      this.setting();
    },
    checkSP(breakpoint) {
      return window.matchMedia('(max-width: ' + breakpoint +'px)').matches;
    },
    scroll(scroller) {
      // console.log(scroller);
      // console.log(this.scrollTop(), scroller.scrollTop());
    },
    scrollTop() {
      return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
    },
    reset() {
      window.scrollTo(0, 0);
      this.resizeObserver.unobserve(document.body);
      this.resizeObserver.disconnect();

      if (this.ScrollSmoother) {
        this.ScrollSmoother.scrollTo(0, 0);
        this.ScrollSmoother.kill();
        this.ScrollSmoother = null;
        window.scrollTo(0, 0);
      }

      let triggers = ScrollTrigger.getAll();
      triggers.forEach(function (trigger) {
          trigger.kill();
      });

      this.scrollObjects.forEach((el) => {
        if (el === '.c-category__thumb') {
          gsap.set(`${el} .is-wrap`, {clearProps: true});
          gsap.set(`${el} .is-wrap-image`, {clearProps: true});
        } else {
          gsap.set(el, {clearProps: true});
        }
      });
      this.scrollObjects = [];

      this.$refs['categoryThumb1'].reset();
      this.$refs['categoryThumb2'].reset();
      this.$refs['categoryThumb3'].reset();

      this.$store.commit('setHeadBlack', false);

      this.$refs['mv'].reset();
    }
  }
}
</script>